import { useIsMenuNavPhase1Enabled } from '@ms/yammer-features-app-navigation';
import React, { ReactNode, useMemo } from 'react';

import { UserProfileMenuButton } from '../../UserProfileMenuButton';

type UseUserProfileLinkActionButtons = () => ReactNode[] | undefined;
export const useUserProfileLinkActionButtons: UseUserProfileLinkActionButtons = () => {
  const isMenuNavPhase1Enabled = useIsMenuNavPhase1Enabled();

  return useMemo(() => {
    const userProfileMenuButton = <UserProfileMenuButton />;

    return isMenuNavPhase1Enabled ? [userProfileMenuButton] : undefined;
  }, [isMenuNavPhase1Enabled]);
};
